/**
 * QMS Timeline Hook
 * React Query hook for ticket timeline/activity history
 */

import { useQuery } from '@tanstack/react-query';
import { fetchQmsTimeline } from '../api/qmsApi';
import type { QmsTimelineEvent } from '../types/qms.types';
import { qmsKeys } from './useQmsBoard';

// Re-export timeline keys from qmsKeys for backward compatibility
export const qmsTimelineKeys = {
  all: ['qms', 'timeline'] as const,
  ticket: (ticketId: string) => qmsKeys.timeline(ticketId),
};

/**
 * Hook to fetch timeline events for a ticket
 */
export function useQmsTimeline(ticketId: string) {
  return useQuery<QmsTimelineEvent[]>({
    queryKey: qmsKeys.timeline(ticketId),
    queryFn: () => fetchQmsTimeline(ticketId),
    staleTime: 30 * 1000, // 30 seconds - shorter to catch activity updates quickly
  });
}
